import { defineRouting } from "next-intl/routing";
import {
  defaultLocale,
  localePrefixes,
  locales,
} from "./locales";
import { pathnames } from "./pathnames";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: {
    mode: "as-needed",
    prefixes: localePrefixes,
  },
  // Resolve locale from the URL only — never from Accept-Language or a cookie.
  localeDetection: false,
  localeCookie: false,
  // Manual per-page hreflang generation ensures only enabled/translated locales are advertised.
  alternateLinks: false,
  pathnames,
});

